import { createContext, useContext, useState } from "react"

interface State {
  showBottomSheet: boolean
  yearlySelected: boolean
}

interface Actions {
  setShowBottomSheet: (show: boolean) => void
  setYearlySelected: (selected: boolean) => void
}

interface Context {
  state: State
  actions: Actions
}

const MultiStepContext = createContext<Context | null>(null)

const MultiStepProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [showBottomSheet, setShowBottomSheet] = useState<boolean>(false)
  const [yearlySelected, setYearlySelected] = useState<boolean>(true)

  const state: State = {
    showBottomSheet,
    yearlySelected,
  }
  const actions: Actions = {
    setShowBottomSheet,
    setYearlySelected,
  }

  return (
    <MultiStepContext.Provider value={{ state, actions }}>
      {children}
    </MultiStepContext.Provider>
  )
}

const useMultiStep = () => {
  const context = useContext(MultiStepContext)

  if (!context) {
    throw new Error("useMultiStep must be used within <Provider>")
  }

  return context
}

export { MultiStepProvider, MultiStepContext, useMultiStep }
